export const matchesTeams = {
  matches: [
    {
      matchId: 'match-001',
      status: 'COMPLETED',
      stage: 'Fase de grupos',
      group: 'Grupo J',
      displayDate: '27 DE MARZO',
      displayTime: '19:00',
      timeZoneLabel: 'ARG',
      isWinner: true,
      isDraw: false,
      isLose: false,
      broadcast: { isAvailable: false, groupId: null },
      matchProgress: null,
      homeTeam: {
        teamId: 'CIV',
        name: 'Costa de Marfil',
        flagUrl: 'https://images.clarovideo.com/esg-images/GNA5MGHG2ZVX2RD/flags/CIV_flag.png',
        primaryHex: '#02AC66',
        score: 3,
      },
      awayTeam: {
        teamId: 'AUT',
        name: 'Austria',
        flagUrl: 'https://images.clarovideo.com/esg-images/GNA5MGHG2ZVX2RD/flags/AUT_flag.png',
        primaryHex: '#F77F00',
        score: 1,
      },
    },
    {
      matchId: 'match-001',
      status: 'COMPLETED',
      stage: 'Fase de grupos',
      group: 'Grupo J',
      displayDate: '27 DE MARZO',
      displayTime: '19:00',
      timeZoneLabel: 'ARG',
      isWinner: false,
      isDraw: false,
      isLose: true,
      broadcast: { isAvailable: false, groupId: null },
      matchProgress: null,
      homeTeam: {
        teamId: 'CIV',
        name: 'Costa de Marfil',
        flagUrl: 'https://images.clarovideo.com/esg-images/GNA5MGHG2ZVX2RD/flags/CIV_flag.png',
        primaryHex: '#02AC66',
        score: 1,
      },
      awayTeam: {
        teamId: 'AUT',
        name: 'Austria',
        flagUrl: 'https://images.clarovideo.com/esg-images/GNA5MGHG2ZVX2RD/flags/AUT_flag.png',
        primaryHex: '#F77F00',
        score: 3,
      },
    },
    {
      matchId: 'match-001',
      status: 'COMPLETED',
      stage: 'Fase de grupos',
      group: 'Grupo J',
      displayDate: '27 DE MARZO',
      displayTime: '19:00',
      timeZoneLabel: 'ARG',
      isWinner: false,
      isDraw: true,
      isLose: false,
      broadcast: { isAvailable: false, groupId: null },
      matchProgress: null,
      homeTeam: {
        teamId: 'CIV',
        name: 'Costa de Marfil',
        flagUrl: 'https://images.clarovideo.com/esg-images/GNA5MGHG2ZVX2RD/flags/CIV_flag.png',
        primaryHex: '#02AC66',
        score: 3,
      },
      awayTeam: {
        teamId: 'AUT',
        name: 'Austria',
        flagUrl: 'https://images.clarovideo.com/esg-images/GNA5MGHG2ZVX2RD/flags/AUT_flag.png',
        primaryHex: '#F77F00',
        score: 3,
      },
    },
    {
      matchId: 'match-002',
      status: 'IN_PROGRESS',
      stage: 'Fase de grupos',
      group: 'Grupo J',
      displayDate: '18 DE JUNIO',
      displayTime: '19:00',
      timeZoneLabel: 'ARG',
      isWinner: false,
      isDraw: false,
      isLose: false,
      broadcast: { isAvailable: true, groupId: '64524' },
      matchProgress: {
        period: 'SECOND_HALF',
        hour: null,
        minute: 67,
        second: 12,
      },
      homeTeam: {
        teamId: 'CIV',
        name: 'Costa de Marfil',
        flagUrl: 'https://images.clarovideo.com/esg-images/GNA5MGHG2ZVX2RD/flags/CIV_flag.png',
        primaryHex: '#F77F00',
        score: 2,
      },
      awayTeam: {
        teamId: 'QAT',
        name: 'Qatar',
        flagUrl: 'https://images.clarovideo.com/esg-images/GNA5MGHG2ZVX2RD/flags/QAT_flag.png',
        primaryHex: '#F77F00',
        score: 1,
      },
    },
    {
      matchId: 'match-003',
      status: 'IN_PROGRESS',
      stage: 'Fase de grupos',
      group: 'Grupo J',
      displayDate: '22 DE JUNIO',
      displayTime: '16:00',
      timeZoneLabel: 'ARG',
      isWinner: false,
      isDraw: false,
      isLose: false,
      broadcast: { isAvailable: false, groupId: null },
      matchProgress: {
        period: 'FIRST_HALF',
        hour: 1,
        minute: 29,
        second: 44,
      },
      homeTeam: {
        teamId: 'CIV',
        name: 'Costa de Marfil',
        flagUrl: 'https://images.clarovideo.com/esg-images/GNA5MGHG2ZVX2RD/flags/CIV_flag.png',
        primaryHex: '#F77F00',
        score: 0,
      },
      awayTeam: {
        teamId: 'QAT',
        name: 'Qatar',
        flagUrl: 'https://images.clarovideo.com/esg-images/GNA5MGHG2ZVX2RD/flags/QAT_flag.png',
        primaryHex: '#F77F00',
        score: 0,
      },
    },
    {
      matchId: 'match-004',
      status: 'SCHEDULED',
      stage: 'Fase de grupos',
      group: 'Grupo J',
      displayDate: '26 DE JUNIO',
      displayTime: '21:00',
      timeZoneLabel: 'ARG',
      isWinner: false,
      isDraw: false,
      isLose: false,
      broadcast: { isAvailable: false, groupId: null },
      matchProgress: null,
      homeTeam: {
        teamId: 'CIV',
        name: 'Costa de Marfil',
        flagUrl: 'https://images.clarovideo.com/esg-images/GNA5MGHG2ZVX2RD/flags/CIV_flag.png',
        primaryHex: '#F77F00',
        score: null,
      },
      awayTeam: {
        teamId: 'JOR',
        name: 'Jordania',
        flagUrl: 'https://images.clarovideo.com/esg-images/GNA5MGHG2ZVX2RD/flags/JOR_flag.png',
        primaryHex: '#F77F00',
        score: null,
      },
    },
    {
      matchId: 'match-005',
      status: 'SCHEDULED',
      stage: 'Fase de grupos',
      group: 'Grupo J',
      displayDate: '30 DE JUNIO',
      displayTime: '18:00',
      timeZoneLabel: 'ARG',
      isWinner: false,
      isDraw: false,
      isLose: false,
      broadcast: { isAvailable: false, groupId: null },
      matchProgress: null,
      homeTeam: {
        teamId: 'CIV',
        name: 'Costa de Marfil',
        flagUrl: 'https://images.clarovideo.com/esg-images/GNA5MGHG2ZVX2RD/flags/CIV_flag.png',
        primaryHex: '#F77F00',
        score: null,
      },
      awayTeam: {
        teamId: null,
        name: 'Por definir',
        flagUrl: 'https://images.clarovideo.com/esg-images/GNA5MGHG2ZVX2RD/flags/PLACEHOLDER_flag.png',
        primaryHex: '#F77F00',
        score: null,
      },
    },
  ],
};
